import gql from 'graphql-tag';

export default gql`
  query getUser {
    user {
      id
      email
      language
      agreement {
        agreedToMobileTerms
        notShownAgreement
        allowResearch
        dateAgreedToMobileTerms
      }
    }
  }
`;
